export enum EVideos {
  boy = 'boy',
  shoe = 'shoe',
}
